import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { AccountService } from './account.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getAcceptLanguage } from '../helpers/getAcceptLanguage';
import { environment } from '../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PdvService {
  constructor(private api: BaseApiService,
    private accountService: AccountService,) { }

  knjiziIzRIM(params: any): Observable<any> {
    return this.api
      .post('pdv/knjizi-iz-rim', params)
      .pipe(catchError(this.handleError<[]>(`pdv/knjizi-iz-rim`)));
  }

  getEIsporuke(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/e-isporuke`,
      {
        godina: params.godina,
        mjesec: params.mjesec,
        redniBroj: params.redniBroj
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getENabavke(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/e-nabavke`,
      {
        godina: params.godina,
        mjesec: params.mjesec,
        redniBroj: params.redniBroj
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;
      return throwError(error);
    };
  }
}
